import { z } from 'zod';
import { ValidationEntrySeveritySchema } from '../../../../../react-commons/components/ValidationEntrySeverity';
import { msObject } from '../../resource-base/msObject';

const ValidationEntryProjectArchetypeTargetSchema = msObject({
    severity: ValidationEntrySeveritySchema,
    canBeDeactivated: z.boolean(),
    deactivated: z.boolean(),
    canSeverityBeChanged: z.boolean(),
});

// export type ValidationEntryProjectArchetypeTarget = z.infer<typeof ValidationEntryProjectArchetypeTargetSchema>;

const ValidationEntryDetailsResourceSchema = msObject({
    defaultSeverity: ValidationEntrySeveritySchema,
    displayName: z.string(),
    condition: z.string(),
    property: z.string().optional(),
    properties: z.string().array().nullish(),
    description: z.string().nullable(),
    persistableTypeFilter: z.string().array().nullable(),
});

export type ValidationEntryDetailsResource = z.infer<typeof ValidationEntryDetailsResourceSchema>;

export const ValidationEntryDetailsPayloadSchema = msObject({
    property: z.record(z.string(), ValidationEntryDetailsResourceSchema),
    child: z.record(z.string(), ValidationEntryDetailsResourceSchema),
    compound: z.record(z.string(), ValidationEntryDetailsResourceSchema),
});

export type ValidationEntryDetailsPayload = z.infer<typeof ValidationEntryDetailsPayloadSchema>;
